import { useLanguage } from "../../stores/LanguageStore";
import { IconAlertTriangleFilled } from "@tabler/icons-react";
import { Logo } from "../../layouts/Logo";
import { Button, Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useSessionStore } from "../../stores/UserStore";
import { Link, useNavigate } from "react-router-dom";

const MobileGuard = ({ isSignup, onClose }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);

  const navigate = useNavigate();
  const handleNav = () => {
    modals.close("mobile-guard");
    onClose();
    navigate("/leads-tracking");
  };

  const handleClose = () => {
    modals.close("mobile-guard");
    onClose();
  };

  return (
    <Stack py={32} px={4} gap={0}>
      <Logo w={250} mx="auto" mb={32} />

      <ThemeIcon size={64} mx={"auto"}>
        <IconAlertTriangleFilled size={64} />
      </ThemeIcon>
      <Text size="lg" fw={600} my={16} ta={"center"}>
        {lang.signup.mobile_text1.replace("#", reseller?.name)}
      </Text>
      {isSignup && (
        <Text size="lg" mb={32} ta={"center"}>
          {lang.signup.mobile_text2.replace("#", reseller?.name)}
        </Text>
      )}

      <Group>
        <Button
          onClick={handleClose}
          size="md"
          variant="outline"
          flex={1}
        >
          {lang.global.close}
        </Button>
        <Button onClick={handleNav} size="md" flex={1}>
          {lang.signup.mobile_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default MobileGuard;
